/*
  Promotion badge market gate.

  Product cards render country-excluded badges hidden because Shopify resolves
  almost every visitor to the primary market on this store. This file uses the
  existing IP result from theme.js to remove excluded badges or reveal the rest.
*/
(function () {
  if (window.__verishPromoBadgeMarketGate) return;
  window.__verishPromoBadgeMarketGate = true;

  var ATTR = 'data-market-except';
  var PICK_KEY = 'verish-country-pick';

  function readPick() {
    try {
      return (sessionStorage.getItem(PICK_KEY) || '').trim().toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function cookieCountry() {
    var match = document.cookie.match(/(?:^|;\s*)localization=([^;]+)/);
    return match ? decodeURIComponent(match[1]).trim().toUpperCase() : '';
  }

  function honouredPick() {
    var stored = readPick();
    if (!stored) return '';

    var cookie = cookieCountry();
    if (cookie && cookie !== stored) {
      try {
        sessionStorage.removeItem(PICK_KEY);
      } catch (error) {}
      return '';
    }
    return stored;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var option = target.closest('[data-disclosure-country] [data-disclosure-option]');
      if (!option) return;

      var code = (option.getAttribute('data-value') || '').trim().toUpperCase();
      if (!code) return;

      try {
        sessionStorage.setItem(PICK_KEY, code);
      } catch (error) {}
    },
    true
  );

  function cachedCountry() {
    var fromMemory = window.FoxTheme && window.FoxTheme.country;
    if (fromMemory) return fromMemory;

    try {
      return sessionStorage.getItem('detectedCountry') || '';
    } catch (error) {
      return '';
    }
  }

  function isTwPath(pathname) {
    return pathname === '/tw' || pathname.indexOf('/tw/') === 0;
  }

  function effectiveCountry(cached, pathname) {
    var picked = honouredPick();
    if (picked) return picked;
    if (isTwPath(pathname)) return 'TW';
    return String(cached || '').trim().toUpperCase();
  }

  function resolved(cached, pathname) {
    if (honouredPick()) return true;
    if (String(cached || '').trim()) return true;
    if (isTwPath(pathname)) return true;
    return !!(window.FoxTheme && window.FoxTheme.countryDetectionComplete === true);
  }

  function excluded(element, country) {
    return (element.getAttribute(ATTR) || '')
      .toUpperCase()
      .split(',')
      .some(function (code) {
        return code.trim() === country;
      });
  }

  function apply(root) {
    var cached = cachedCountry();
    var pathname = window.location.pathname;
    if (!resolved(cached, pathname)) return;

    var country = effectiveCountry(cached, pathname);
    if (!country) return;

    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[' + ATTR + ']'), function (element) {
      if (excluded(element, country)) element.remove();
      else element.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); }, { once: true });
  } else {
    apply();
  }

  document.addEventListener('country:detected', function () { apply(); });
  document.addEventListener('collection:rerendered', function () { apply(); });
  document.addEventListener('recommendations:loaded', function () { apply(); }, true);
})();
